/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies */
import { tracked } from '@glimmer/tracking';
// Extend From
import Controller from '@ember/controller';
// Ember Imports
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
// External Imports
import config from 'linced-learners/config/environment';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';

export default class ApplicationController extends Controller {
  @action
  setLeftSideBarOpen(value) {
    this.leftSideBarOpen = value;
  }

  @action
  setTermsAccepted(value) {
    this.termsAccepted = value;
  }

  @tracked
  leftSideBarOpen;

  @service
  session;

  @service
  options;

  @service
  router;

  @service
  store;

  @service
  toaster;

  @service
  policyAcceptance;

  Jurisdiction = Jurisdiction;
  PersonType = PersonType;
  currentPageId = null;
  isViewingGoals = false;
  isViewingStudentNotices = false;
  @tracked
  termsAccepted = false;
  publicRoutes = config.APP.publicRoutes;

  @computed('router.currentRouteName')
  get isPublicRoute() {
    let current = this.router.currentRouteName;
    return this.publicRoutes.includes(current);
  }

  @optionAlias('core:studentGoalSetting:enabled')
  goalSettingEnabled;

  @computed('session.person.fullName')
  get pageTitle() {
    let fullName = this.get('session.person.fullName') ?? '';
    return `${fullName} | Hero`;
  }

  @action
  acceptTerms() {
    return this.policyAcceptance.acceptTerms();
  }

  init() {
    super.init(...arguments);

    let spinner = document.querySelector('#preloader');
    spinner.parentElement.removeChild(spinner);
  }
}
